<template>
  <div>
    <b-table
      v-if="items.length"
      small
      responsive
      hover
      striped
      sticky-header="600px"
      :items="items"
      :fields="fields"
      :tbody-tr-class="rowClass"
      class="reports-table"
      :class="{ 'table-sticky-dark': this.$user.getTheme() === 'dark' }"
    >
      <template #head()="data">
        <p class="font-weight-bolder" style="min-height: 18px">
          {{ data.label }}
        </p>
        <p class="font-weight-bolder text-lowercase" style="min-height: 18px">
          {{ data.field.secondLabel }}
        </p>
      </template>
    </b-table>
    <b-skeleton-table
      v-else
      :rows="25"
      :columns="13"
      :table-props="{ striped: true }"
      animation="wave"
    />
  </div>
</template>
<script>
  export default {
    name: 'order-report-table',
    components: {
    },
    props: {
      filters: Object,
      companyPlasmaPro: Boolean
    },
    data () {
      return {
        fields: [
          {
            key: 'salesSystemNumber',
            label: 'ID',
            tdClass: "text-nowrap"
          },
          {
            key: this.companyPlasmaPro ? 'catalogue' : 'orderId',
            label: this.companyPlasmaPro ? 'Kataloog' : 'Projekti nr',
            tdClass: "text-nowrap"
          },
          {
            key: this.companyPlasmaPro ? 'object' : 'projectName',
            label: this.companyPlasmaPro ? 'Objekt' : 'Projekti nimi',
            tdClass: "text-nowrap"
          },
          {
            key: 'client',
            label: 'Klient',
            tdClass: "text-nowrap"
          },
          {
            key: 'materialPrice',
            label: 'Materjali kulu',
            tdClass: "text-nowrap",
            formatter: (value, key, item) => value ? value.toFixed(2) + ' €' : '0 €'
          },
          {
            key: 'workcenterPrice',
            label: 'Töökeskuste kulu',
            secondLabel: 'Omahind',
            tdClass: "text-nowrap",
            formatter: (value, key, item) => value ? value.toFixed(2) + ' € ' : '0 €'
          },
          {
            key: 'workcenterPriceActual',
            label: '',
            secondLabel: 'Tegelik',
            tdClass: "text-nowrap",
            formatter: (value, key, item) => value ? value.toFixed(2) + ' €' : '0 €'
          },
          {
            key: 'totalPrice',
            label: 'Kulu kokku',
            secondLabel: 'Omahind',
            tdClass: "text-nowrap",
            formatter: (value, key, item) => value ? value.toFixed(2) + ' €' : '0 €'
          },
          {
            key: 'totalPriceActual',
            label: '',
            secondLabel: 'Tegelik',
            tdClass: "text-nowrap",
            formatter: (value, key, item) => value ? value.toFixed(2) + ' €' : '0 €'
          },
          {
            key: 'salePrice',
            label: 'Müügihind',
            tdClass: "text-nowrap",
            formatter: (value, key, item) => value ? value.toFixed(2) + ' €' : '0 €'
          },
          {
            key: 'marginal',
            label: 'Marginaal',
            secondLabel: 'Omahind',
            tdClass: "text-nowrap",
            formatter: (value, key, item) => value ? value.toFixed(2) + ' €' : '-'
          },
          {
            key: 'marginalActual',
            label: '',
            secondLabel: 'Tegelik',
            tdClass: "text-nowrap",
            formatter: (value, key, item) => value ? value.toFixed(2) + ' €' : '-'
          },
          {
            key: 'marginalPercentage',
            label: 'Marginaal [%]',
            secondLabel: 'Omahind',
            tdClass: "text-nowrap",
            formatter: (value, key, item) => value ? value.toFixed(1) + ' %' : '-'
          },
          {
            key: 'marginalPercentageActual',
            label: '',
            secondLabel: 'Tegelik',
            tdClass: "text-nowrap",
            formatter: (value, key, item) => value ? value.toFixed(1) + ' %' : '-'
          }
        ],
        items: []
      }
    },
    async created () {
      await this.generateReport()
    },

    methods: {
      rowClass (item, type) {
        if (!item || type !== 'row') return
        if (item.accent) return 'row-accent'
      },
      async generateReport () {
        const filters = {
          ...this.filters.status && { status: this.filters.status },
          ...this.filters.startDate && { startDate: this.filters.startDate },
          ...this.filters.endDate && { endDate: this.filters.endDate },
          ...this.filters.salesSystemNumber && { salesSystemNumber: this.filters.salesSystemNumber },
          ...this.filters.orderId && { orderId: this.filters.orderId },
          ...this.filters.projectName && { projectName: this.filters.projectName },
          ...this.filters.client && { client: this.filters.client },
          ...this.filters.catalogue && { client: this.filters.catalogue },
          ...this.filters.object && { client: this.filters.object },
        }

        this.items = (await this.$reports.getOrderReport(filters)).data
      }
    }
  }
</script>
<style lang="scss">
.row-accent {
  font-weight: 800;
  & + tr td {
    border-color: rgba(255, 255, 255, 0.5)!important;
    padding-top: 10px!important;
  }
}
</style>
